import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  ul: {
    background: theme.palette.card.cardColor,
    color: theme?.palette?.card?.cardFontColor,
    "& ul": {
      color: theme.palette.card.cardFontColor,
      background: theme.palette.card.cardColor,
    },
  },
  selectMenu: {
    background: theme.palette.card.cardColor,
    "& li": {
      color: theme.palette.card.cardFontColor,
    },
  },
}));

function CheckoutTimePicker({
  slots = [],
  className,
  value,
  onChange = () => {},
  onClick = () => {},
  setTime = () => {},
}) {
  const classes = useStyles();
  const [selectedTime, setSelectedTime] = useState("");

  // Update selectedTime when value prop changes
  useEffect(() => {
    if (value && value.value) {
      // Check if the value is an ISO timestamp (from Redux)
      if (value.value.includes('T') && value.value.includes('Z')) {
        // Extract the time from the ISO timestamp
        const timeFromRedux = moment(value.value);
        const timeString = timeFromRedux.format("HH:mm");
        
        // Find the matching time slot from available slots
        if (slots.length > 0) {
          const matchingSlot = slots.find(slot => {
            // Extract time from slot value (which might be ISO string or time string)
            let slotTime;
            if (slot.value.includes('T') && slot.value.includes('Z')) {
              slotTime = moment(slot.value).format("HH:mm");
            } else {
              slotTime = moment(slot.value, "HH:mm").format("HH:mm");
            }
            return slotTime === timeString;
          });
          
          if (matchingSlot) {
            setSelectedTime(matchingSlot.value);
          } else {
            setSelectedTime(slots[0].value);
          }
        }
      } else {
        // If it's not an ISO timestamp, use it as is
        setSelectedTime(value.value);
      }
    }
  }, [value, slots]);

  // Set default time if no value is provided and slots are available
  useEffect(() => {
    if (!selectedTime && slots.length > 0 && !value?.value) {
      setSelectedTime(slots[0].value);
    }
  }, [slots, selectedTime, value]);

  // Update parent's time state when selectedTime changes
  useEffect(() => {
    if (selectedTime) {
      setTime(selectedTime);
    }
  }, [selectedTime, setTime]);

  const handleChange = (e) => {
    const selected = slots.find((slot) => slot.value === e.target.value);
    setSelectedTime(e.target.value);
    if (selected && onChange) {
      onChange(selected, "time");
    }
  };

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <FormControl variant="outlined" className={className}>
      <Select
        labelId="delivery-time"
        id="delivery-time-select"
        value={selectedTime}
        onChange={handleChange}
        onClick={handleClick}
        label="Time"
        MenuProps={{
          classes: { paper: classes.selectMenu },
        }}
        className={`font-weight-bold ${classes.ul}`}
      >
        {slots.map((elem, key) => (
          <MenuItem key={`option-${key}`} value={elem.value}>
            {elem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CheckoutTimePicker.defaultProps = {
  slots: [],
  className: "",
  value: null,
  onChange: () => {},
  onClick: () => {},
  setTime: () => {},
};

CheckoutTimePicker.propTypes = {
  slots: PropTypes.array,
  className: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  setTime: PropTypes.func,
};

export default CheckoutTimePicker; 